import colors from '@/assets/scss/_themes-vars.module.scss'
import { getEnv } from '@/utils/helpers'

declare module '@mui/material/styles/createPalette' {
  interface TypeBackground {
    idle: string
  }
}

export function getPalette() {
  const primaryEnv = getEnv('VITE_PRIMARY_COLOR')
  const secondaryEnv = getEnv('VITE_SECONDARY_COLOR')

  return {
    common: {
      black: '#000',
      white: '#FFF',
    },
    primary: primaryEnv
      ? { main: primaryEnv }
      : {
          light: colors.primaryLight,
          main: colors.primaryMain,
          dark: colors.primaryDark,
        },
    secondary: secondaryEnv
      ? { main: secondaryEnv }
      : {
          light: colors.secondaryLight,
          main: colors.secondaryMain,
          dark: colors.secondaryDark,
        },
    // info: {},
    // success: {},
    // warning: {},
    // error: {},
    background: {
      paper: colors.paper,
      default: colors.background,
      idle: colors.gray200,
    },
    // action: {

    // }
  }
}
